import type { PayloadAction } from '@reduxjs/toolkit';

import type { SetShowPayload, SetStatePayload } from './_reducer.type';
import type { DialogSideState, SideState } from './_state.type';

/** Side Reducer. */
export const sideReducer = {
  /**
   * Set state DialogSide.
   *
   * @param {SideState} state State.
   * @param {PayloadAction<SetStatePayload>} action Action.
   */
  side_setState: (state: SideState, { payload }: PayloadAction<SetStatePayload>) => {
    state.side.states[payload.key] = payload.state;
  },

  /**
   * Set show state DialogSide.
   *
   * @param {SideState} state State.
   * @param {PayloadAction<SetShowPayload>} action Action.
   */
  side_setShow: (state: SideState, { payload }: PayloadAction<SetShowPayload>) => {
    const nextState: DialogSideState = {
      ...state.side.states[payload.key],
      show: payload.show,
      shouldTriggerEvent: true,
    };

    if (payload.show) {
      const showDialogs = Object.entries(state.side.states).filter(([dialogName, dialogState]) => payload.key !== dialogName && dialogState?.show);
      nextState.isTransparentOverlay = showDialogs.length > 0;
    }

    state.side.states[payload.key] = nextState;
  },

  /**
   * Remove DialogSide.
   *
   * @param {SideState} state State.
   * @param {PayloadAction<string>} action Action.
   */
  side_remove: (state: SideState, { payload }: PayloadAction<string>) => {
    delete state.side.states[payload];
  },
};
